import { FormBuilder, FormGroup, FormArray, Validators, FormControl, NgForm  } from '@angular/forms';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';;
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-contactos',
  templateUrl: './contactos.component.html',
  styleUrls: ['./contactos.component.scss']
})
export class contactsComponent implements OnInit {

  @Input() contacts;
  @Input() noModifyAll;
  @Output() refreshContact: EventEmitter<any> = new EventEmitter();
  newContact: FormGroup;
  contact: FormArray;
  emailPattern = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$';

  constructor(
    public translate: TranslateService,
    public fb: FormBuilder) {
    this.newContact = this.fb.group({
      contact: this.fb.array([ this.createItem() ])
    });
    this.newContact.get('contact').valueChanges.subscribe(
      data => {
        if (data) {
          const lastItem = data.length - 1;
          if ( data[lastItem].nameContact && data[lastItem].contactPhone1 && data[lastItem].emailContact ) {
            if (data[lastItem].emailContact.match(this.emailPattern)) {
            this.addItem();
            }
          }
        }
      }
    );
  }

  createItem(): FormGroup {
    return this.fb.group({
      nameContact: '',
      surnamesContact: '',
      contactPosition: '',
      contactPhone1: '',
      contactPhone2: '',
      emailContact: ['', [Validators.required, Validators.pattern(this.emailPattern)]],
    });
  }

  showErrorMail() { }

  addItem(): void {
    this.contact = this.newContact.get('contact') as FormArray;
    this.contact.push(this.createItem());
  }

  ngOnInit() { }

  deleteContact(contact) {
    this.refreshContact.emit(contact);
  }

  deleteRowContact(i) {
    this.contact.removeAt(i);
  }

  refreshForm () {
    this.newContact.reset();
    if (this.contact) {
      while (this.contact.length !== 1) {
        this.contact.removeAt(0);
      }
    }
  }

}
